import { all } from 'redux-saga/effects'

import auth from './auth/saga'
import cerc from './cerc/saga'

export default function* rootSaga(): any {
    return yield all([
        auth,
        cerc
    ])
}